import styled from 'styled-components';

export const DescriptionBlock = styled.p`
  margin: 0;
  white-space: pre-line;
  overflow-wrap: anywhere;
  font-size: 0.875rem;
  line-height: 1.6;
  color: ${({ theme }) => theme.dark};
`;

export const AttachmentGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
`;

export const AttachmentThumb = styled.a`
  display: block;
  width: 6rem;
  height: 6rem;
  border-radius: 0.5rem;
  border: 1px solid ${({ theme }) => theme.grey};
  overflow: hidden;
  background: ${({ theme }) => theme.lightGrey};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  &:hover {
    border-color: ${({ theme }) => theme.primary};
  }
`;

export const AttachmentFallback = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 6rem;
  height: 6rem;
  border-radius: 0.5rem;
  border: 1px dashed ${({ theme }) => theme.grey};
  background: ${({ theme }) => theme.lightGrey};
  color: ${({ theme }) => theme.midGrey};
  font-size: 0.75rem;
  text-align: center;
`;

export const DecisionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

export const ReasonInput = styled.textarea`
  width: 100%;
  box-sizing: border-box;
  min-height: 4.5rem;
  resize: vertical;
  margin-bottom: 0.75rem;
  padding: 0.75rem 0.9rem;
  border: 1px solid ${({ theme }) => theme.grey};
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.dark};
  font-family: inherit;
  font-size: 0.875rem;
  line-height: 1.5;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primary};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.lightGrey};
  }
`;

export const ExecutedNote = styled.p`
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.midGrey};
`;

export const StatusText = styled.span<{ $tone?: 'positive' | 'negative' | 'muted' | 'warning' }>`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${({ theme, $tone }) => {
    if ($tone === 'positive') return theme.positive;
    if ($tone === 'negative') return theme.negative;
    if ($tone === 'warning') return theme.middle;
    return theme.midGrey;
  }};
`;
